import { createActions, createReducer } from "reduxsauce";
import { onChangeFieldValue } from "utils/functions";
import { defaultState } from "./users-model";

export const { Types, Creators } = createActions({
  usersShowLoading: [],
  usersHideLoading: [],
  usersShowLoadingTable: [],
  usersHideLoadingTable: [],
  usersFetchAsync: [],
  usersUpdateFilter: ["filter"],
  usersUpdateUser: ["editUser"],
  usersUpdateUserAsync: ["body"],
  usersFetchRegister: ["items", "totalItems"],
  usersChangeFieldValue: ["fieldName", "value"],
  usersRolesList: ["rolesList"],
  usersRolesFetchAsync: [],
  usersEditActive: ["editActive"],
  usersUpdateFormModified: ["formViewOrEditModified"],
  usersFetchByIdAsync: ["id"],
  usersClearFilterTable: [],
});

export const showLoading = (state = defaultState) => ({
  ...state,
  isLoading: true,
});

export const hideLoading = (state = defaultState) => ({
  ...state,
  isLoading: false,
});

export const showLoadingTable = (state = defaultState) => ({
  ...state,
  isLoadingTable: true,
});

export const hideLoadingTable = (state = defaultState) => ({
  ...state,
  isLoadingTable: false,
});

export const fetchUsers = (state, { items, totalItems }) => ({
  ...state,
  isLoading: false,
  items,
  totalItems,
});

export const changeFieldValue = (state, { fieldName, value }) => ({
  ...state,
  filter: onChangeFieldValue(state.filter, fieldName, value),
});

export const updateFilter = (state, action: any) => {
  return {
    ...state,
    searchFilter: action.filter,
  };
};

export const editUser = (state, action: any) => ({
  ...state,
  editUser: action.editUser,
});

export const setRolesList = (state, { rolesList }) => ({
  ...state,
  ...rolesList,
});

export const editActive = (state, action: any) => ({
  ...state,
  editActive: action.editActive,
});

export const updatformViewOrEditModified = (state, action: any) => ({
  ...state,
  formViewOrEditModified: action.formViewOrEditModified,
});

export const clearFilterTable = (state = defaultState) => ({
  ...state,
  filter: {
    orderBy: "",
    ascend: "",
    itemsByPage: 10,
    pageIndex: 1,
  },
});

export default createReducer(defaultState, {
  [Types.USERS_SHOW_LOADING]: showLoading,
  [Types.USERS_HIDE_LOADING]: hideLoading,
  [Types.USERS_SHOW_LOADING_TABLE]: showLoadingTable,
  [Types.USERS_HIDE_LOADING_TABLE]: hideLoadingTable,
  [Types.USERS_FETCH_REGISTER]: fetchUsers,
  [Types.USERS_CHANGE_FIELD_VALUE]: changeFieldValue,
  [Types.USERS_UPDATE_FILTER]: updateFilter,
  [Types.USERS_UPDATE_USER]: editUser,
  [Types.USERS_ROLES_LIST]: setRolesList,
  [Types.USERS_EDIT_ACTIVE]: editActive,
  [Types.USERS_UPDATE_FORM_MODIFIED]: updatformViewOrEditModified,
  [Types.USERS_CLEAR_FILTER_TABLE]: clearFilterTable,
});
